<template>
  <div class="label-container" :style="{ backgroundColor: `rgba(var(--v-theme-${color}), 0.07)` }">
    <div v-if="dot" class="dot" :style="{ backgroundColor: `rgb(var(--v-theme-${color}))` }"></div>
    <span class="label-text" :class="`text-${color}`">{{ text === "Created" ? "Fetching questions" : text }}</span>
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    required: true,
  },
  dot: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: "primary",
  },
});
</script>

<style scoped>
.label-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 6px;
}

.dot:before {
  content: "";
  display: inline-block;
}
.label-text {
  font-size: 14px;
  font-weight: 500;
}
</style>
